import React from "react";
import "./Plashka.css";

const AskCompany = () => {
  return (
    <div className="plashka_wrap">
      <div className="plashka container">
        <p className="plashka_text">Node.js is a registered trademark of the OpenJS Foundation</p>
      </div>
    </div>
  );
};
export default AskCompany;
